import {useAtom} from 'jotai'

import store from '..'

export const useCommonDispatch = () => {
  const [, dispatch] = useAtom(store)

  const setCommonQuery = (query: any) => {
    dispatch({type: 'COMMON/SET_QUERY', payload: query})
  }

  return {
    setCommonQuery,
  }
}
